{
    "title": "Metric Metadata",
    "description": "JSON schema of metric metadata, the default configuration of the barChart, scatterPlot, timeSeries, and sparkline modules",
    "version": "0.14.0",
    "type": "object",
    "modules": {
        "barChart": {
            "required": false
        },
        "groupOverview": {
            "required": true
        },
        "scatterPlot": {
            "required": false
        },
        "sparkline": {
            "required": false
        },
        "timeSeries": {
            "required": false
        }
    },
    "required": [
        "MetricID",
        "GroupLevel",
        "Abbreviation",
        "Numerator",
        "Denominator",
        "Metric",
        "Score",
        "Threshold"
    ],
    "properties": {
        "MetricID": {
            "title": "Metric ID",
            "description": "Unique metric identifier",
            "type": "string",
            "required": false,
            "key": false
        },
        "GroupLevel": {
            "title": "Grouping Variable",
            "description": "Grouping variable of metric, one of 'Site', 'Country', or 'Study'",
            "type": "string",
            "required": false,
            "key": false
        },
        "Abbreviation": {
            "title": "Abbreviation",
            "description": "Metric Abbreviation",
            "type": "string",
            "required": false,
            "key": false
        },
        "Numerator": {
            "title": "Metric Numerator",
            "description": "Unit of metric numerator",
            "type": "string",
            "required": false,
            "key": false
        },
        "Denominator": {
            "title": "Metric Denominator",
            "description": "Unit of metric denominator",
            "type": "string",
            "required": false,
            "key": false
        },
        "Metric": {
            "title": "Metric Description",
            "description": "Description of metric",
            "type": "string",
            "required": false,
            "key": false
        },
        "Score": {
            "title": "Metric Score",
            "description": "Analysis method of metric",
            "type": "string",
            "required": false,
            "key": false
        },
        "Threshold": {
            "title": "Thresholds",
            "description": "Thresholds for metric",
            "type": "string",
            "required": false,
            "key": false
        }
    }
}
